import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

export class TicketTypePicker extends PickerBase{
    static readonly JsonTypeName = "Ticket Type";
    static readonly ElementId = "Ticket.TicketType";
    static readonly defaultLabel = "Ticket Type";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = TicketTypePicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = TicketTypePicker.defaultLabel;

        if(TicketTypePicker.pickerChoices){
            this.displayChoices = TicketTypePicker.pickerChoices;
        }

        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return TicketTypePicker.JsonTypeName;
    }
}

export class TicketTypePickerPeer extends TypedCardElementPeer<TicketTypePicker> {
    static displayLabelProperty = getPropertyEditorInstance(TicketTypePicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(TicketTypePicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(TicketTypePicker.ElementId, PropertyKeys.dataSource, []);

    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(TicketTypePicker.ElementId, PropertyKeys.dataSource, choices);
    }

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            TicketTypePickerPeer.idProperty,
            TicketTypePickerPeer.displayLabelProperty,
            TicketTypePickerPeer.requireFieldProperty,
            TicketTypePickerPeer.dataSourceProperty);
    
    }
}